<template>
  <div class="content-wrapper">

    <div class="title">
<!--      <el-divider content-position="center" style="font-size: 25px;">欢迎使用，请留下您的联系方式</el-divider>-->
      欢迎使用，请留下您的联系方式
    </div>

    <el-form :inline="true" ref="accountRule" :rules="accountRule" :hide-required-asterisk="true" :model="formInline" class="content">
      <el-form-item label="单位名称:" prop="unitName">
        <el-input v-model="formInline.unitName" placeholder="单位名称"></el-input>
      </el-form-item>
      <el-form-item label="姓名:" prop="contactName">
        <el-input v-model="formInline.contactName" placeholder="姓名" style="width: 130px;"></el-input>
      </el-form-item>
      <el-form-item label="手机号:" prop="contactPhone">
        <el-input v-model="formInline.contactPhone" placeholder="手机号" style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item label="需求备注:">
        <el-input v-model="formInline.remark" placeholder="需求备注"></el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="smsCode">
        <el-input v-model="formInline.smsCode" style="width: 100px;" placeholder="验证码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isShowSendCode" type="primary" @click="onClickSendCode" style="width: 100px;" size="small">验证码</el-button>
        <el-button v-else plain style="width: 100px;" size="small" disabled>{{'重新获取' + sendCodeCountDown + '秒'}}</el-button>
      </el-form-item>
    </el-form>
    <div style="text-align: center;">
      <el-button type="success" @click="onSubmit">立即提交</el-button>
      <div v-if="isSubmit" style="font-size: 20px; color: red; margin-top: 5px;">已收到，请耐心等待回复！</div>
    </div>

    <el-dialog
      title="滑动验证"
      :visible.sync="centerDialog.Visible"
      width="30%"
      append-to-body
      center
    >
      <div v-loading="slideLoading" style="width: 300px;margin: 10px auto">
        <slideImg ref="slideImg" v-model="formInline.authCode" @login="slideRegisting" />
      </div>

    </el-dialog>
  </div>
</template>

<script>
import homeApi from '@/api/home'
import {cleanObj, isNullOrUndefined} from '@/utils'
import slideImg from '@/views/expertRegister/components/slideImg/index.vue'

export default {
  name: 'ContactUs',
  components: {slideImg},
  data () {
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[345789]\d{9}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      timer: null,
      isShowSendCode: true,
      sendCodeCountDown: 60,
      formInline: {
        contactName: '',
        contactPhone: '',
        remark: '',
        unitName: '',
        smsCode: '',
        token: ''
      },
      accountRule: {
        contactPhone: [{required: true, validator: checkPhone, trigger: 'blur'}],
        smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        contactName: [{required: true, message: '请输入真实姓名', trigger: 'blur'}],
        unitName: [{required: true, message: '请输入采购单位名称', trigger: 'blur'}],
      },
      isSubmit: false,
      centerDialog: {
        Visible: false,
        msg: '',
        data: null
      },
      slideLoading: false
    }
  },
  methods: {
    slideRegisting(authCodeToken, authCode) {
      this.formInline.smsCode = ''
      homeApi.contactUsSendSmsCode({phoneNum: this.formInline.contactPhone, authCodeToken, authCode}).then(data => {
        /* 【发送完短信验证码】后调整为【倒计时状态】 */
        this.isShowSendCode = false
        this.timer = setInterval(() => {
          if (this.sendCodeCountDown > 0 && this.sendCodeCountDown <= 60) {
            this.sendCodeCountDown--
          } else {
            /* 【倒计时结束】后调整为【可点击状态】 */
            clearInterval(this.timer)
            this.timer = null
            this.sendCodeCountDown = 60
            this.isShowSendCode = true
          }
        }, 1000)
        console.log('data', data)
        this.formInline.token = data.token
        this.centerDialog.Visible = false
        this.$message.success('验证成功，请查收短信')
      }).catch(e => {
        this.$refs.slideImg.getContractSlideImage()
      }).finally(() => {
        this.slideLoading = false
      })
    },
    // 发送验证码
    onClickSendCode() {
      if (!isNullOrUndefined(this.formInline.contactPhone)) {
        this.$refs['accountRule'].validateField('contactPhone', (errorMessage) => {
          if (!errorMessage) {
            this.centerDialog.Visible = true
            this.$nextTick(() => {
              this.$refs.slideImg.getContractSlideImage()
            })
          }
        })
      } else {
        this.$message.warning('请输入手机号码')
        this.$refs['accountRule'].validateField('contactPhone')
      }
    },
    // 提交联系人信息
    onSubmit() {
      this.$refs['accountRule'].validate((valid) => {
        if (valid) {
          homeApi.submitContactInfo(this.formInline).then(res => {
            cleanObj(this.formInline)
            this.$message({
              type: 'success',
              message: '提交成功！',
              duration: 5000
            })
            this.isSubmit = true
          })
        } else {
          this.$message.warning('请检查必填项！')
        }
      })

    }
  }
}
</script>

<style scoped lang="less">
.content-wrapper {
  width: 100%;
  //background: url("@/assets/images/product/contact-bg.png");
  background: url("../../assets/images/product/contact-bg.png");
  padding: 30px 0;
  position: relative;
  .title {
    padding-top: 20px;
    font-size: 35px;
    text-align: center;
  }

  .content {
    width: 1400px;
    margin: 30px auto 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/contactUs/index.vue